import { AfterViewChecked, AfterViewInit, ChangeDetectorRef, Component, effect, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { lastValueFrom } from 'rxjs';

//material
import { MatButtonModule } from '@angular/material/button';

//constants
import { ParamsConstants, RoutesConstants, StorageConstants } from '../shared/constants';

//helpers
import { NavigatorHelper, StorageHelper } from '../shared/helpers';

//services
import { ApiService } from '../shared/services/api.service';
import { AppTypeEnum } from '../shared/enums';
import { MatIconModule } from '@angular/material/icon';
import { MatDialog } from '@angular/material/dialog';
import { InfoDialogComponent } from '../shared/dialogs/info-dialog/info-dialog.component';
import { StockingHomeComponent } from "./components/stocking-home/stocking-home.component";
import { BindingHomeComponent } from "./components/binding-home/binding-home.component";
import { TestingHomeComponent } from "./components/testing-home/testing-home.component";

@Component({
  selector: 'app-home',
  imports: [MatButtonModule, RouterModule, MatIconModule, StockingHomeComponent, BindingHomeComponent, TestingHomeComponent],
  standalone: true,
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss'
})
export class HomeComponent implements AfterViewInit {
  @ViewChild('binding') binding!: ElementRef;
  @ViewChild('testing') testing!: ElementRef;
  @ViewChild('stocking') stocking!: ElementRef;

  constructor(
    private route: ActivatedRoute,
  ) {
    effect(() => {
      this.scrollTo(NavigatorHelper.appType() || AppTypeEnum.binding);
    })
  }

  async ngAfterViewInit() {
    setTimeout(() => {
      let appType = this.route.snapshot.queryParams[ParamsConstants.APP_TYPE] as AppTypeEnum | null;
      if (appType) {
        NavigatorHelper.appType.set(appType);
        this.scrollTo(appType, true);
        return;
      }
      appType = StorageHelper.getItem<AppTypeEnum>(StorageConstants.APP_TYPE);
      console.log(appType)
      if (appType) {
        NavigatorHelper.appType.set(appType);
        this.scrollTo(appType, true);
        return;
      }
    }, 1);
  }

  private scrollTo(page: AppTypeEnum, instant: boolean = false) {

    const pageMap: Record<AppTypeEnum, ElementRef> = {
      [AppTypeEnum.binding]: this.binding,
      [AppTypeEnum.testing]: this.testing,
      [AppTypeEnum.stocking]: this.stocking,
    };
    console.log(pageMap[page]?.nativeElement)
    pageMap[page]?.nativeElement.scrollIntoView({ behavior: instant ? 'instant' : 'smooth', block: 'center' });
  }

}
